import { computed, onBeforeUnmount, ref, watch } from 'vue'

/**
 * 86bcbu2dc / 86bce6r42: the self report checkout's discount countdown.
 *
 * The server owns the deadline and sends the seconds left with every page
 * load, so the clock restarts from that count each time it changes rather
 * than drifting on its own.
 *
 * @param {() => number} secondsFromServer
 */
export function useCountdown(secondsFromServer) {
    const secondsLeft = ref(0)
    let timer = null

    const stop = () => {
        if (timer) {
            clearInterval(timer)
            timer = null
        }
    }

    const start = (seconds) => {
        stop()
        secondsLeft.value = Math.max(0, Math.floor(seconds || 0))
        if (secondsLeft.value === 0) {
            return
        }
        timer = setInterval(() => {
            secondsLeft.value = Math.max(0, secondsLeft.value - 1)
            if (secondsLeft.value === 0) {
                stop()
            }
        }, 1000)
    }

    watch(secondsFromServer, start, { immediate: true })
    onBeforeUnmount(stop)

    const countdown = computed(() => {
        const minutes = Math.floor(secondsLeft.value / 60)
        const seconds = String(secondsLeft.value % 60).padStart(2, '0')
        return `${minutes}:${seconds}`
    })

    return { secondsLeft, countdown }
}
